import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id"];
import trans from '../../services/Translator';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FieldControlInfo',
    props: {
        form: {},
        validation: {},
        field: {},
        fieldId: {},
        data: {}
    },
    setup(__props) {
        const props = __props;
        function value() {
            if (!props.data) {
                return;
            }
            // shortcut if data cannot be translation key
            if (props.data.indexOf(' ') !== -1) {
                return props.data;
            }
            const key1 = `${props.form.name}.${props.field.name}.${props.data}`;
            const key2 = `${props.field.name}.${props.data}`;
            return trans(key1, {}, () => trans(key2, {}, props.data));
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                id: __props.fieldId,
                class: "form__control"
            }, _toDisplayString(value()), 9, _hoisted_1));
        };
    }
});
